import { Link } from "@tanstack/react-router";
import { SiteHeader } from "@/components/site-header";
import { SiteFooter } from "@/components/site-footer";

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28">
        <div className="max-w-2xl text-center">
          <h1 className="font-display text-5xl sm:text-6xl text-foreground">
            404
          </h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Sidan du sökte finns inte. Den kan ha flyttats eller tagits bort.
          </p>
          <div className="mt-8 flex justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-lg bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground hover:bg-primary/90"
            >
              Till startsidan
            </Link>
            <Link
              to="/kallor"
              className="inline-flex items-center justify-center rounded-lg border border-border bg-background px-5 py-2.5 text-sm font-medium text-foreground hover:bg-muted"
            >
              Se källor
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
